export function getErrorPropName(error) {
  var name = error.property;
  return name.indexOf('.') === 0 ? name.substr(1) : name;
}
export function isCheckbox(uiSchema, propName) {
  var uiProp = uiSchema[propName];
  return uiProp && uiProp['ui:widget'] === 'checkboxes';
}
function getFirstInputFieldSelector(uiSchema, propName) {
  var id = "_".concat(propName).replace(/(\[|]\.)/g, '_').replace(/\./g, '_');
  // focus on exact control or first checkbox/radio that is prefixed with the control id
  return "#".concat(id, ",input[id^=\"").concat(id, "\"]");
}
function getStickyHeaderClearance() {
  var stickyHeader = document.querySelector('._page-header--sticky');
  if (stickyHeader) {
    var clientRect = stickyHeader.getBoundingClientRect();
    return clientRect.height + clientRect.top;
  }
  return 0;
}
function populateProperties(uiSchema, currentLayout, prefix, destination) {
  currentLayout.forEach(function (item) {
    var type = item.type;
    if (item.id && item.id.length) {
      if (type === 'field' && uiSchema[item.id] && uiSchema[item.id]['dm:layout']) {
        type = 'object';
      }
      switch (type) {
        case 'field':
          destination.push("".concat(prefix, ".").concat(item.id));
          break;
        case 'group':
          if (item.children && item.children.length) {
            populateProperties(uiSchema, item.children, prefix, destination);
          }
          break;
        case 'object':
          var objectSchema = uiSchema[item.id];
          if (objectSchema && objectSchema['dm:layout']) {
            populateProperties(uiSchema, objectSchema['dm:layout'], "".concat(prefix, ".").concat(item.id), destination);
          }
          break;
        case 'array':
          var _prefix = "".concat(prefix, ".").concat(item.id);
          var arraySchema = uiSchema[item.id];
          if (arraySchema && arraySchema.items && arraySchema.items['dm:layout']) {
            populateProperties(uiSchema, arraySchema.items['dm:layout'], _prefix, destination);
          }
          break;
      }
    }
  });
}
function getOrderedProperties(uiSchema) {
  var result = [];
  var rootLayout = uiSchema['dm:layout'];
  if (rootLayout && rootLayout.length) {
    populateProperties(uiSchema, rootLayout, '', result);
  }
  return result;
}
function getSortedFieldErrors(uiSchema, errors) {
  var arrayIndexRegex = /\[\d+]/g;
  var arrayPartsRegex = /(.+\[)(\d+)/;
  var propertiesArray = getOrderedProperties(uiSchema);
  var toPropertyArrayId = function toPropertyArrayId(error) {
    return error.property.replace(arrayIndexRegex, '');
  };
  var fieldErrors = errors.filter(function (error) {
    var result = !!(error.property && error.property.length);
    if (result) {
      result = propertiesArray.indexOf(toPropertyArrayId(error)) !== -1;
    }
    return result;
  });
  var baseFieldSort = function baseFieldSort(left, right) {
    var leftId = toPropertyArrayId(left);
    var rightId = toPropertyArrayId(right);
    var leftPos = propertiesArray.indexOf(leftId);
    var rightPos = propertiesArray.indexOf(rightId);
    return leftPos - rightPos;
  };
  fieldErrors.sort(function (left, right) {
    var result = 0;
    if (arrayPartsRegex.test(left.property) && arrayPartsRegex.test(right.property)) {
      var leftFieldParts = left.property.match(arrayPartsRegex);
      var rightFieldParts = right.property.match(arrayPartsRegex);
      if (leftFieldParts && rightFieldParts && leftFieldParts[1] === rightFieldParts[1]) {
        // same dsa
        if (leftFieldParts[2] === rightFieldParts[2]) {
          // same row
          result = baseFieldSort(left, right);
        } else if (leftFieldParts.length >= 3) {
          result = Number(leftFieldParts[2]) - Number(rightFieldParts[2]);
        }
      } else {
        result = baseFieldSort(left, right);
      }
    } else {
      result = baseFieldSort(left, right);
    }
    return result;
  });
  return fieldErrors;
}
function getInputContainer(el) {
  var parent, result;
  parent = el.parentElement;
  if (parent) {
    if (" ".concat(parent.className, " ").indexOf(' _dm-input-container ') !== -1) {
      result = parent;
    } else {
      result = getInputContainer(parent);
    }
  }
  return result;
}
function getErrorMessage(input) {
  var inputContainer = getInputContainer(input);
  return inputContainer ? inputContainer.querySelector('._dm-inline-error') : null;
}

// additional spacing so elements scrolled into view aren't touching viewport
var SCROLL_CLEARANCE = 20;
function focusInViewport(input) {
  var errorElement = getErrorMessage(input);
  var inputClientRect = input.getBoundingClientRect();
  var inputTop = inputClientRect.top;
  var requiredClearance = getStickyHeaderClearance();
  // input is on the screen, but under sticky header
  if (inputTop > 0 && inputTop < requiredClearance) {
    var scrollYAdjustment = requiredClearance - inputTop + SCROLL_CLEARANCE;
    window.scrollTo(window.scrollX, window.scrollY - scrollYAdjustment);
  } else if (errorElement) {
    // timeout because browser will scroll on focus, which may move message into view
    setTimeout(function () {
      var viewportHeight = document.documentElement.clientHeight || window.innerHeight;
      var errorMessageRect = errorElement.getBoundingClientRect();
      // the validation message is not visible in viewport
      if (errorMessageRect.bottom > viewportHeight) {
        var _scrollYAdjustment = errorMessageRect.bottom - viewportHeight + SCROLL_CLEARANCE;
        window.scrollTo(window.scrollX, window.scrollY + _scrollYAdjustment);
      }
    });
  }
  input.focus();
}
function timedOutFocus(inputSelector, timedOut) {
  var input = document.querySelector(inputSelector);
  if (input) {
    focusInViewport(input);
  } else if (!timedOut) {
    setTimeout(function () {
      timedOutFocus(inputSelector, true);
    });
  }
}
function focusErrorField(uiSchema, errors, formId) {
  if (errors) {
    var inputSelector = errors.map(function (error) {
      var propName = getErrorPropName(error);
      return getFirstInputFieldSelector(uiSchema, propName + formId);
    }).join(',');
    timedOutFocus(inputSelector);
  }
}
export function focusFirstErrorField(uiSchema, errors, formId) {
  focusErrorField(uiSchema, getSortedFieldErrors(uiSchema, errors), formId);
}
export function focusInViewportCenter(input) {
  try {
    var docEl = document.documentElement;
    var body = document.body;
    var rect = input.getBoundingClientRect();
    var scrollTop = window.pageYOffset || docEl.scrollTop || body.scrollTop;
    var wHeight = document.documentElement.clientHeight || window.innerHeight;
    var desired = scrollTop + rect.top - (wHeight - rect.height) * 0.5;
    window.scrollTo(window.scrollX, desired);
  } catch (error) {
    // just fallback to browser focus/scroll
  }
  input.focus();
}

// Needed or build will break without an export default
export default {
  isCheckbox: isCheckbox,
  getErrorPropName: getErrorPropName,
  focusFirstErrorField: focusFirstErrorField,
  focusInViewport: focusInViewport,
  focusInViewportCenter: focusInViewportCenter
};